<template>
	<ModalBase
		container-class="rounded-lg p-8 w-full md:w-3/4 lg:w-[45em] border-2 border-popup-border bg-popup-bg text-popup-text"
		ref="baseModal">
		<div class="w-full text-right">
			<IconsFontAwesome
				icon="fa-solid fa-xmark"
				class="hover:cursor-pointer"
				@click="closeModal" />
		</div>
		<p class="font-serif text-3xl text-center">{{ $t("refundableInfoTitle") }}</p>

		<div class="font-thin flex flex-col gap-4 py-5 md:px-14 md:py-10">
			<p>{{ $t("refundableInfoBody1") }}</p>
			<ul class="list-disc pl-10">
				<li>
					{{ $t("refundableInfoReason1a") }}
					<NuxtLink
						to="https://www.refundable.me/covid/"
						target="_blank"
						class="underline"
						>{{ $t("refundableInfoReason1b") }}
					</NuxtLink>
				</li>
				<li>{{ $t("refundableInfoReason2") }}</li>
				<li>{{ $t("refundableInfoReason3") }}</li>
				<li>{{ $t("refundableInfoReason4") }}</li>
				<li>{{ $t("refundableInfoReason5") }}</li>
				<li>{{ $t("refundableInfoReason6") }}</li>
				<li>{{ $t("refundableInfoReason7") }}</li>
				<li>{{ $t("refundableInfoReason8") }}</li>
				<li>{{ $t("refundableInfoReason9") }}</li>
			</ul>
			<p>
				{{ $t("refundableInfoMore1") }}
				<NuxtLink
					to="https://www.refundable.me/extended/en/"
					target="_blank"
					class="underline"
					>{{ $t("refundableInfoMore2") }}
				</NuxtLink>
			</p>
		</div>
	</ModalBase>
</template>

<script setup>
	import { CART_CLEARED } from "assets/events/cart.js"

	const { $eventBus } = useNuxtApp()
	const baseModal = ref(null)

	const openModal = () => baseModal.value.openModal()

	const closeModal = () => baseModal.value.closeModal()

	onMounted(() => {
		$eventBus.$on(CART_CLEARED, closeModal)
	})

	onUnmounted(() => {
		$eventBus.$off(CART_CLEARED)
	})

	defineExpose({
		openModal,
	})
</script>

<style lang="scss" scoped></style>
